import { OutlinedInput, OutlinedInputProps } from '@aibees/shared/components';
import { useDebounceFn } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import * as Styled from './styles';
import type { SearchBarFilterProps as Props } from './types';

export const SearchBarFilter = memo(
  ({ className, filters, setFilter }: Props) => {
    const [inputValue, setInputValue] = useState<string>(filters.name ?? '');

    const handleButtonClick = (value: string) => {
      setFilter('name', value);
    };

    const handleClickDebounced = useDebounceFn(handleButtonClick, 500);

    const handleKeyDown: OutlinedInputProps['onKeyDown'] = (event) => {
      if (event.key === 'Enter') {
        handleButtonClick(inputValue);
      }
    };

    const handleInputChange = (event: any) => {
      const { value } = event.currentTarget;
      setInputValue(value);
      handleClickDebounced(value);

      if (!event.currentTarget.value) {
        setFilter('name', undefined);
      }
    };

    return (
      <Styled.Wrapper className={classnames('SearchBarFilter ', className)}>
        <OutlinedInput
          value={inputValue}
          placeholder="Type To Search ..."
          size="small"
          startIcon="search"
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          fullWidth
          sx={{ flex: 1 }}
        />
      </Styled.Wrapper>
    );
  }
);

SearchBarFilter.displayName = 'SearchBarFilter';
